// extracted by mini-css-extract-plugin
export var circle = "_g6-1";
export var exitConfirmationModal = "_g6-5";
export var iframe = "_g6-0";
export var offline = "_g6-3";
export var online = "_g6-2";
export var workstationSelectError = "_g6-4";